import { Button, Divider, Dropdown, Menu, Space, Table, Tooltip, Empty, Badge, Select } from 'antd'
import AddSiteModal from './add-site-modal'
import { useEffect, useMemo, useState } from 'react'
import ReactECharts from 'echarts-for-react'
import * as echarts from 'echarts'
import styled from 'styled-components'
import { FilterDropdownProps } from 'antd/lib/table/interface'
import { DeleteModal, IconFont, SignTitle, SvgIcon, TableTag, FilterFormSelect } from '@/components'
import { ShowTotal } from '@/components/show-total'
import { BatchAddModal } from './batch-add-modal'
import { DeviceConfigModal } from './device-config-modal'
import {
  useDeleteSite,
  useGetDeviceProducer,
  useGetSiteList,
  useGetFingerprint,
  useGetSiteAnalyzeOverview,
  useGetSiteDeviceFilterList,
  useGetSiteOsDistribution,
  useGetSiteComponentDistribution,
} from './utils'
import { SiteDetailModal } from './detail-modal'
import EditSiteModal from './edit-site-modal'
import EmptyImg from '@/assets/imges/Empty/Empty.png'
import bg from '@/assets/imges/站点分析.png'
import siteIcon from '@/assets/imges/站点.png'
import { useSelections } from 'ahooks'
import { formatDateTime } from '@/utils/date'
import FilterIcon from '@/pages/program/temporary/widgets/filter-icon'
import { t } from '@/i18n'

const SiteList = () => {
  const [addVisible, setAddVisible] = useState(false)
  const [editVisible, setEditVisible] = useState({ id: '', visible: false, originFrom: null })
  const [batchAddVisible, setBatchAddVisible] = useState(false)
  const [configVisible, setConfigVisible] = useState<{ id: string[]; visible: boolean }>({
    id: [],
    visible: false,
  })
  const [deleteVisible, setDeleteVisible] = useState<{ visible: boolean; id: string[] }>({
    visible: false,
    id: [],
  })
  const [detail, setDetail] = useState({
    visible: false,
    id: null,
    auth_status: null,
    originFrom: null,
  })
  const [filterParams, setFilterParams] = useState({ size: 10, page: 1 })
  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([])
  const closeBatchAddModal = val => {
    setBatchAddVisible(false)
    if (val) {
      getData()
    }
  }
  const detailCancel = (v: boolean) => {
    if (v) {
      setEditVisible({ visible: true, id: detail.id, originFrom: detail.originFrom })
    }
    setDetail({ visible: false, id: null, auth_status: null, originFrom: detail.originFrom })
  }

  const [deleteSite, deleteSiteLoad] = useDeleteSite()
  const [siteList, getSiteList, siteListLoading] = useGetSiteList()
  const [fingerprintData, getFingerprint, fingerprintLoading] = useGetFingerprint()
  const [deviceList, getDeviceList] = useGetDeviceProducer()
  const [analyzeData, getAnalyzeData] = useGetSiteAnalyzeOverview()
  const [siteDeviceFilterList] = useGetSiteDeviceFilterList()
  const [getSiteOsDistribution, siteOsDistribution] = useGetSiteOsDistribution()
  const [getSiteComponentDistribution, siteComponentDistribution] =
    useGetSiteComponentDistribution()

  const [assetDistributionType, setAssetDistributionType] = useState('os')
  const [osSelectOpen, setOsSelectOpen] = useState(false)

  const [selectedValue, setSelectedValue] = useState<{
    field: string | number
    value: string | number | string[] | number[]
  }>({
    field: '',
    value: '',
  })

  const { selected, setSelected, toggleAll } = useSelections<string>(
    siteList?.list?.map(item => item.id) || [],
  )

  const getData = () => {
    setSelectedRowKeys([])
    getSiteList({ ...filterParams }).catch(_ => {})
    getAnalyzeData().catch(() => {})
    const runner =
      assetDistributionType === 'os' ? getSiteOsDistribution : getSiteComponentDistribution
    runner().catch(() => {})
  }
  useEffect(() => {
    getData()
  }, [filterParams])

  useEffect(() => {
    if (selectedValue.field) {
      setFilterParams(prev => ({
        ...prev,
        page: 1,
        [selectedValue.field]: selectedValue.value,
      }))
    }
  }, [selectedValue])

  const deviceCover = useMemo(() => {
    const resultArray: { name: string; value: number; count: number }[] = []
    if (analyzeData?.deviceCoverageRate) {
      resultArray.push({
        name: t('有防护'),
        value: Number((analyzeData?.deviceCoverageRate / 100).toFixed(2)),
        count: analyzeData?.protectedAliveCount,
      })
    } else {
      resultArray.push({
        name: t('有防护'),
        value: 0,
        count: 0,
      })
    }
    if (analyzeData?.deviceUnCoverageRate) {
      resultArray.push({
        name: t('无防护'),
        value: Number((analyzeData?.deviceUnCoverageRate / 100).toFixed(2)),
        count: analyzeData?.unprotectedAliveCount,
      })
    } else {
      resultArray.push({
        name: t('无防护'),
        value: 0,
        count: 0,
      })
    }
    if (analyzeData?.deviceUnknownCoverageRate) {
      resultArray.push({
        name: t('未知'),
        value: Number((analyzeData?.deviceUnknownCoverageRate / 100).toFixed(2)),
        count: analyzeData?.unknownAliveCount,
      })
    } else {
      resultArray.push({
        name: t('未知'),
        value: 0,
        count: 0,
      })
    }
    return resultArray
  }, [analyzeData])

  const siteVerify = useMemo(() => {
    const resultArray: { name: string; value: number; count: number }[] = []
    if (analyzeData?.siteValidationRate) {
      resultArray.push({
        name: t('已验证'),
        value: Number((analyzeData?.siteValidationRate / 100).toFixed(2)),
        count: analyzeData?.verifiedAssetCount,
      })
    } else {
      resultArray.push({
        name: t('已验证'),
        value: 0,
        count: 0,
      })
    }
    if (100 - analyzeData?.siteValidationRate / 100) {
      resultArray.push({
        name: t('未验证'),
        value:
          analyzeData?.siteValidationRate === 0
            ? 0
            : 100 - Number((analyzeData?.siteValidationRate / 100).toFixed(2)),
        count: analyzeData?.unverifiedAssetCount,
      })
    } else {
      resultArray.push({
        name: t('未验证'),
        value: 0,
        count: 0,
      })
    }
    return resultArray
  }, [analyzeData])

  const option1 = () => ({
    tooltip: {
      trigger: 'item',
      extraCssText: 'border-radius: 4px;',
      formatter: (params: any) => {
        const value = params.data.count
        return `<div>
          <span style="display: inline-block; margin-right: 8px; width: 6px; height: 6px; background-color: ${params.color}; border-radius: 50%;"></span>
          <span>${params.name}</span>
          <span onclick="console.log(params, value)">${value}</span>
        </div>`
      },
    },
    title: {
      text: t('防护覆盖率'),
      subtext: `${analyzeData?.deviceCoverageRate / 100 || 0}%`,
      left: 'center',
      top: '42%',
      textStyle: {
        color: '#666',
        fontSize: 14,
        fontWeight: 'normal',
      },
      subtextStyle: {
        color: '#333',
        fontSize: 16,
        fontWeight: 500,
      },
    },
    label: {
      position: 'outer',
      alignTo: 'edge',
      margin: 2,
      color: '#999',
    },
    color: ['#4C45B5', '#716ADD', '#C1BBEB'],
    series: [
      {
        type: 'pie',
        top: '0%',
        radius: ['40%', '70%'],
        data: deviceCover,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.2)',
          },
        },
      },
    ],
  })

  const option2 = () => ({
    tooltip: {
      trigger: 'item',
      formatter: (params: any) => {
        const value = params.data.count
        return `<div>
          <span style="display: inline-block; margin-right: 8px; width: 6px; height: 6px; background-color: ${params.color}; border-radius: 50%;"></span>
          <span>${params.name}</span>
          <span>${value}</span>
        </div>`
      },
    },
    title: {
      text: t('验证率'),
      subtext: `${analyzeData?.siteValidationRate / 100 || 0}%`,
      left: 'center',
      top: '40%',
      textStyle: {
        color: '#666',
        fontSize: 14,
        fontWeight: 'normal',
      },
      subtextStyle: {
        color: '#333',
        fontSize: 16,
        fontWeight: 500,
      },
    },
    label: {
      position: 'outer',
      alignTo: 'edge',
      margin: 2,
      color: '#999',
      // formatter: '{b}: {c}%',
    },
    color: ['#2090A8', '#90C8D3'],
    series: [
      {
        type: 'pie',
        top: '0%',
        radius: ['40%', '70%'],
        data: siteVerify,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.2)',
          },
        },
      },
    ],
  })

  const assetDistributionChartData = useMemo(() => {
    const list = assetDistributionType === 'os' ? siteOsDistribution : siteComponentDistribution
    return (list || [])
      .map(item => ({
        name:
          assetDistributionType === 'os'
            ? item?.osName || t('未知')
            : item?.componentName || t('未知'),
        value: item?.count || 0,
      }))
      .sort((a, b) => b.value - a.value)
  }, [assetDistributionType, siteComponentDistribution, siteOsDistribution])

  const MAX_VISIBLE_ASSET_BARS = 4

  const option3 = () => ({
    grid: {
      left: 58,
      right: '6%',
      top: '6%',
      bottom: 52,
      containLabel: false,
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      formatter: params => {
        if (!Array.isArray(params) || !params.length) return ''
        const { name, value } = params[0]
        return `${name}<br/>${t('数量')}：${value || 0}`
      },
    },
    xAxis: {
      type: 'value',
      min: 0,
      max: 100,
      interval: 25,
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: {
        lineStyle: {
          color: '#F0F2F5',
        },
      },
      axisLabel: {
        color: '#95A1B3',
      },
    },
    yAxis: {
      type: 'category',
      data: assetDistributionChartData.map(item => item.name),
      axisTick: { show: false },
      axisLine: { show: false },
      axisLabel: {
        color: '#5E6673',
        width: 48,
        overflow: 'truncate',
        ellipsis: '...',
        align: 'right',
      },
    },
    dataZoom:
      assetDistributionChartData.length > MAX_VISIBLE_ASSET_BARS
        ? [
            {
              id: 'assetDistributionDataZoom',
              type: 'inside',
              yAxisIndex: 0,
              startValue: 0,
              endValue: MAX_VISIBLE_ASSET_BARS - 1,
              rangeMode: ['value', 'value'],
              minValueSpan: MAX_VISIBLE_ASSET_BARS,
              maxValueSpan: MAX_VISIBLE_ASSET_BARS,
              moveHandleSize: 0,
              showDetail: false,
              zoomOnMouseWheel: true,
              moveOnMouseMove: true,
              moveOnMouseWheel: true,
              preventDefaultMouseMove: true,
              filterMode: 'none',
              throttle: 100,
            },
          ]
        : [],
    series: [
      {
        type: 'bar',
        barWidth: 16,
        data: assetDistributionChartData.map(item => item.value),
        itemStyle: {
          color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
            { offset: 0, color: '#C1BBEB' },
            { offset: 1, color: '#4C45B5' },
          ]),
          borderRadius: [0, 0, 0, 0],
        },
        label: {
          show: false,
          position: 'top',
          color: '#4F5A69',
        },
      },
    ],
  })

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    console.log(pagination, filters, sorter)
    setFilterParams({
      ...filterParams,
      page: pagination.current,
      size: pagination.pageSize,
      ...filters,
      alive: filters.alive?.length > 0 ? filters.alive[0] : null,
      originFrom: filters.originFrom?.length > 0 ? filters.originFrom[0] : null,
    })
  }

  const generateMenu = (id: string, originFrom: any) => {
    const items = [
      {
        key: '1',
        label: t('编辑'),
        icon: <IconFont type="icon-bianji" />,
        onClick: () => {
          setEditVisible({ id: id, visible: true, originFrom: originFrom })
        },
      },
      {
        key: '4',
        label: t('删除'),
        onClick: () => {
          setDeleteVisible({ visible: true, id: [id] })
        },
        icon: <IconFont type="icon-shanchu-m" />,
      },
    ]
    return <Menu items={items} />
  }

  const columns = [
    {
      title: t('站点'),
      dataIndex: 'site',
      ellipsis: true,
      width: 250,
      render: text => (
        <Tooltip getPopupContainer={() => document.body} title={text}>
          {text || '-'}
        </Tooltip>
      ),
    },
    {
      title: t('站点名称'),
      dataIndex: 'siteName',
      ellipsis: true,
      width: 200,
      render: (_, record) => (
        <Tooltip getPopupContainer={() => document.body} title={record.siteName || record.site}>
          {record.siteName || record.site || '-'}
        </Tooltip>
      ),
    },
    {
      title: (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {t('WAF防护状态')}
        </div>
      ),
      dataIndex: 'defenseStatus',
      key: 'defenseStatus',
      width: 250,
      // filteredValue: filterParams.defenseStatus ? [filterParams.defenseStatus] : [],
      filterDropdown: (props: FilterDropdownProps) => (
        <div style={{ padding: 8, width: 300, position: 'relative' }}>
          <Select
            style={{ width: '100%' }}
            value={props.selectedKeys as string[]}
            open={osSelectOpen}
            getPopupContainer={() => document.body as HTMLElement}
            onDropdownVisibleChange={setOsSelectOpen}
            dropdownClassName="table-filter-dropdown"
            onChange={value => {
              props.setSelectedKeys(value)
              setFilterParams({
                ...filterParams,
                defenseStatus: Array.isArray(value) ? value[0] || undefined : value || undefined,
              })
            }}
            dropdownRender={menu => (
              <div style={{ marginBottom: '6px' }}>
                {menu}
                <Divider style={{ margin: '3px 0 6px 0' }} />
                <Space
                  className="space-btn"
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                  <Button
                    type="default"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.clearFilters?.()
                      setOsSelectOpen(false)
                      setFilterParams({
                        ...filterParams,
                        defenseStatus: undefined,
                      })
                    }}
                  >
                    {t('重置')}
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.confirm()
                      setOsSelectOpen(false)
                    }}
                  >
                    {t('确定')}
                  </Button>
                </Space>
              </div>
            )}
            options={[
              { label: t('有防护'), value: '1' },
              { label: t('无防护'), value: '2' },
              { label: t('未知'), value: '0' },
            ]}
            placeholder={t('请选择')}
            allowClear
          />
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <Tooltip title={t('筛选')} getPopupContainer={() => document.body}>
          <FilterIcon type="icon-a-shaixuan1" $filtered={filtered} />
        </Tooltip>
      ),
      render: (_, record) => (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <Tooltip getPopupContainer={() => document.body}>
            {record?.defenseStatus === 'WafDefenseStatusProtected' ? (
              <span
                style={{
                  display: 'inline-block',
                  background: '#DEE7FF',
                  borderRadius: 4,
                  lineHeight: '18px',
                  fontSize: 12,
                  textAlign: 'center',
                  color: '#3257B9',
                  padding: '0 3px',
                }}
              >
                {t('有防护')}
                {record?.wafName && (
                  <Tooltip getPopupContainer={() => document.body} title={record?.wafName}>
                    <span
                      style={{
                        display: 'inline-block',
                        background: '#C4D5FF',
                        color: '#3257B9',
                        marginLeft: 4,
                        padding: '3px 4px',
                        borderRadius: '0px 4px 4px 0px',
                      }}
                    >
                      {record?.wafName}
                    </span>
                  </Tooltip>
                )}
              </span>
            ) : record?.defenseStatus === 'WafDefenseStatusUnprotected' ? (
              <span
                style={{
                  display: 'inline-block',
                  height: 18,
                  background: '#DEE7FF',
                  borderRadius: 4,
                  lineHeight: '18px',
                  fontSize: 12,
                  textAlign: 'center',
                  color: '#3257B9',
                  padding: '0 3px',
                }}
              >
                {t('无防护')}
              </span>
            ) : (
              <span
                style={{
                  display: 'inline-block',
                  height: 18,
                  background: '#DEE7FF',
                  borderRadius: 4,
                  lineHeight: '18px',
                  fontSize: 12,
                  textAlign: 'center',
                  color: '#3257B9',
                  padding: '0 3px',
                }}
              >
                {t('未知')}
              </span>
            )}
          </Tooltip>
        </div>
      ),
    },
    {
      title: t('影响组件'),
      dataIndex: 'componentSwitch',
      width: 130,
      render: data => (
        <>
          {data === 3 ? (
            <span
              style={{
                display: 'inline-block',
                width: 42,
                height: 18,
                lineHeight: '18px',
                fontSize: 12,
                textAlign: 'center',
                background: '#D9D9D9',
                borderRadius: 4,
                border: '1px solid #BFBFBF',
                color: '#333333',
              }}
            >
              {t('未配置')}
            </span>
          ) : data === 2 ? (
            <span
              style={{
                display: 'inline-block',
                width: 90,
                height: 18,
                background: '#FFE6E5',
                borderRadius: 4,
                border: '1px solid #FBACB2',
                lineHeight: '18px',
                fontSize: 12,
                textAlign: 'center',
                color: '#EE7680',
              }}
            >
              {t('自定义Payload')}
            </span>
          ) : data === 1 ? (
            <span
              style={{
                display: 'inline-block',
                width: 90,
                height: 18,
                background: '#DCEEEE',
                borderRadius: 4,
                border: '1px solid #B2DEDF',
                lineHeight: '18px',
                fontSize: 12,
                textAlign: 'center',
                color: '#64BDC0',
              }}
            >
              {t('通用Payload')}
            </span>
          ) : (
            '-'
          )}
        </>
      ),
    },
    {
      title: t('Web认证'),
      dataIndex: 'authMode',
      width: 130,
      render: data => (
        <>
          {data === 'AuthModeProtocolAuth' ? (
            <span
              style={{
                display: 'inline-block',
                width: 56,
                height: 18,
                background: '#DBE8FF',
                borderRadius: 4,
                lineHeight: '18px',
                fontSize: 12,
                textAlign: 'center',
                color: '#2973FF',
              }}
            >
              {t('协议认证')}
            </span>
          ) : data === 'AuthModeCookieAuth' ? (
            <span
              style={{
                display: 'inline-block',
                width: 76,
                height: 18,
                background: '#DEE7FF',
                borderRadius: 4,
                lineHeight: '18px',
                fontSize: 12,
                textAlign: 'center',
                color: '#3257B9',
              }}
            >
              {t('Cookies认证')}
            </span>
          ) : (
            <span
              style={{
                display: 'inline-block',
                width: 44,
                height: 18,
                lineHeight: '18px',
                fontSize: 12,
                textAlign: 'center',
                background: '#D9D9D9',
                borderRadius: 4,
                color: '#333333',
              }}
            >
              {t('无认证')}
            </span>
          )}
        </>
      ),
    },
    {
      title: t('关联设备'),
      width: 230,
      dataIndex: 'deviceId',
      filterDropdown: (props: FilterDropdownProps) => {
        const safeSelectedKeys = Array.isArray(props.selectedKeys) ? props.selectedKeys : []
        return (
          <div style={{ padding: 8, width: 300 }}>
            <Select
              mode="multiple"
              allowClear
              maxTagCount={'responsive'}
              style={{ width: '100%' }}
              placeholder={t('请选择关联设备')}
              value={safeSelectedKeys}
              onChange={value => {
                if (Array.isArray(value)) {
                  props.setSelectedKeys(value)
                } else {
                  props.setSelectedKeys([value])
                }
              }}
              options={siteDeviceFilterList?.map(item => ({
                label: `${item.deviceType}-${item.deviceName}-${item.deviceIp}`,
                value: item.id,
              }))}
            />
            <div style={{ marginTop: 8, textAlign: 'right' }}>
              <Button onClick={() => props.clearFilters?.()} style={{ marginRight: 8 }}>
                {t('重置')}
              </Button>
              <Button type="primary" onClick={() => props.confirm()}>
                {t('确定')}
              </Button>
            </div>
          </div>
        )
      },
      filterIcon: (filtered: boolean) => (
        <Tooltip title={t('筛选')} getPopupContainer={() => document.body}>
          <FilterIcon filtered={filtered} />
        </Tooltip>
      ),
      render: (_, record) => {
        const devices = record.device || []
        if (devices.length === 0) return '-'
        const visibleDevices = devices.slice(0, 2) // 只显示前两个设备
        const hiddenDevices = devices.slice(2) // 剩余的设备

        return (
          <div
            style={{
              display: 'flex',
              flexWrap: 'nowrap',
              gap: 4,
              maxWidth: '100%',
              overflow: 'hidden',
            }}
          >
            {visibleDevices.map((item, index) => (
              <Tooltip
                key={index}
                title={`${item.deviceType}-${item.deviceName}-${item.deviceIp}`}
                placement="top"
              >
                <span
                  style={{
                    display: 'inline-block',
                    height: 18,
                    background: '#E0E6EA',
                    borderRadius: 4,
                    lineHeight: '18px',
                    fontSize: 12,
                    textAlign: 'center',
                    color: '#677280',
                    maxWidth: 100,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    padding: '0 3px',
                  }}
                >
                  {`${item.deviceType}-${item.deviceName}-${item.deviceIp}`}
                </span>
              </Tooltip>
            ))}
            {hiddenDevices.length > 0 && (
              <Tooltip
                title={
                  <div style={{ maxWidth: 300 }}>
                    {hiddenDevices.map((item, index) => (
                      <div key={index}>
                        {`${item.deviceType}-${item.deviceName}-${item.deviceIp}`}
                      </div>
                    ))}
                  </div>
                }
                placement="top"
              >
                <TableTag background="#F5F5FF" color="#677280" bgColor="#E0E6EA" borderRadius={4}>
                  +{hiddenDevices.length}
                </TableTag>
              </Tooltip>
            )}
          </div>
        )
      },
    },
    {
      title: t('来源类型'),
      width: 100,
      dataIndex: 'originFrom',
      filterDropdown: (props: FilterDropdownProps) => {
        const safeSelectedKeys = Array.isArray(props.selectedKeys) ? props.selectedKeys : []
        return (
          <div style={{ padding: 8, width: 300 }}>
            <Select
              style={{ width: '100%' }}
              placeholder={t('请选择来源类型')}
              value={safeSelectedKeys}
              onChange={value => {
                if (Array.isArray(value)) {
                  props.setSelectedKeys(value)
                } else {
                  props.setSelectedKeys([value])
                }
              }}
              options={[
                { label: t('手动添加'), value: 'OriginFromPortalCustom' },
                { label: t('站点收集'), value: 'OriginFromSiteCollection' },
              ]}
            />
            <div style={{ marginTop: 8, textAlign: 'right' }}>
              <Button onClick={() => props.clearFilters?.()} style={{ marginRight: 8 }}>
                {t('重置')}
              </Button>
              <Button type="primary" onClick={() => props.confirm()}>
                {t('确定')}
              </Button>
            </div>
          </div>
        )
      },
      filterIcon: (filtered: boolean) => (
        <Tooltip title={t('筛选')} getPopupContainer={() => document.body}>
          <FilterIcon filtered={filtered} />
        </Tooltip>
      ),
      render: data => (
        <>
          {data === 'OriginFromCustom' ? (
            <span
              style={{
                color: '#fff',
                background: '#F77B83',
                borderRadius: 4,
                padding: '3px 4px',
                fontSize: 12,
              }}
            >
              {t('手动添加')}
            </span>
          ) : data === 'OriginFromCollection' ? (
            <span
              style={{
                color: '#fff',
                background: '#584EE7',
                borderRadius: 4,
                padding: '3px 4px',
                fontSize: 12,
              }}
            >
              {t('站点收集')}
            </span>
          ) : (
            '-'
          )}
        </>
      ),
    },
    {
      title: t('存活状态'),
      width: 100,
      dataIndex: 'alive',
      filterDropdown: (props: FilterDropdownProps) => {
        const safeSelectedKeys = Array.isArray(props.selectedKeys) ? props.selectedKeys : []
        return (
          <div style={{ padding: 8, width: 300 }}>
            <Select
              style={{ width: '100%' }}
              placeholder={t('请选择存活状态')}
              value={safeSelectedKeys}
              onChange={value => {
                if (Array.isArray(value)) {
                  props.setSelectedKeys(value)
                } else {
                  props.setSelectedKeys([value])
                }
              }}
              options={[
                { label: t('在线'), value: 'AliveStatusTrue' },
                { label: t('离线'), value: 'AliveStatusFalse' },
              ]}
            />
            <div style={{ marginTop: 8, textAlign: 'right' }}>
              <Button onClick={() => props.clearFilters?.()} style={{ marginRight: 8 }}>
                {t('重置')}
              </Button>
              <Button type="primary" onClick={() => props.confirm()}>
                {t('确定')}
              </Button>
            </div>
          </div>
        )
      },
      filterIcon: (filtered: boolean) => (
        <Tooltip title={t('筛选')} getPopupContainer={() => document.body}>
          <FilterIcon filtered={filtered} />
        </Tooltip>
      ),
      render: (_, record) => (
        <>
          {record.aliveStatus === 'AliveStatusTrue' ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Badge status="success" />
              <span style={{ marginLeft: 4 }}>{t('在线')}</span>
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Badge status="default" />
              <span style={{ marginLeft: 4 }}>{t('离线')}</span>
            </div>
          )}
        </>
      ),
    },
    {
      title: t('创建时间'),
      width: 100,
      dataIndex: 'createTime',
      sorter: (a, b) => {
        const dateA = new Date(a.createTime).getTime()
        const dateB = new Date(b.createTime).getTime()
        return dateA - dateB
      },
      render: text => (
        <Tooltip title={formatDateTime(text, 'standard')}>{formatDateTime(text, 'date')}</Tooltip>
      ),
    },
    {
      title: t('操作'),
      width: 120,
      fixed: 'right',
      render: (_, record) => (
        <Space split={<Divider type={'vertical'} style={{ margin: '0 4px' }} />}>
          <div
            style={{ color: '#4238c9', display: 'flex', alignItems: 'center', cursor: 'pointer' }}
            onClick={() => {
              setDetail({
                visible: true,
                id: record.id,
                auth_status: record?.authStatus,
                originFrom: record?.originFrom,
              })
            }}
          >
            <span>{t('详情')}</span>
          </div>
          <ActionBar>
            <Dropdown
              getPopupContainer={() => document.body}
              placement="bottom"
              overlay={generateMenu(record.id, record?.originFrom)}
            >
              <a onClick={e => e.preventDefault()}>
                <Space>
                  <>
                    {t('更多')}
                    <IconFont type={'icon-xiala-'} />
                  </>
                </Space>
              </a>
            </Dropdown>
          </ActionBar>
        </Space>
      ),
    },
  ]

  const handleAssetDistributionChange = (value: string) => {
    setAssetDistributionType(value)
  }

  useEffect(() => {
    const runner =
      assetDistributionType === 'os' ? getSiteOsDistribution : getSiteComponentDistribution
    runner().catch(() => {})
  }, [assetDistributionType, getSiteComponentDistribution, getSiteOsDistribution])

  return (
    <div style={{ height: '100%' }}>
      <AnalysisBox>
        <div className="analysis-box">
          <div className="title">{t('资产统计')}</div>
          <div
            className="site-total"
            style={{
              background: `no-repeat url(${bg})`,
              backgroundSize: '100% 100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexDirection: 'row',
            }}
          >
            <div
              style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
            >
              <div className="total-title">{t('站点总数')}</div>
              <div
                className="total"
                style={{ fontSize: '20px', display: 'flex', alignItems: 'center', marginTop: 15 }}
              >
                <span style={{ fontSize: '24px' }}>{analyzeData?.totalSiteCount || 0}</span>
                {t('个')}
              </div>
            </div>
            <div
              style={{
                marginRight: 8,
                marginTop: 40,
                width: 47,
                height: 50,
                background: `no-repeat url(${siteIcon})`,
                backgroundSize: '100% 100%',
              }}
            />
          </div>
          <div className="survival-total">
            <div className="title">{t('存活资产数量')}</div>
            <div style={{ color: '#677280', display: 'flex', alignItems: 'center' }}>
              <span style={{ fontSize: '20px', fontWeight: 500, color: '#333333' }}>
                {analyzeData?.siteOnlineCount || 0}
              </span>
              {t('个')}
            </div>
          </div>
          <div className="deactivation-total">
            <div className="title">{t('失活资产数量')}</div>
            <div style={{ color: '#677280', display: 'flex', alignItems: 'center' }}>
              <span style={{ fontSize: '20px', fontWeight: 500, color: '#333333' }}>
                {analyzeData?.siteOfflineCount || 0}
              </span>
              {t('个')}
            </div>
          </div>
        </div>
        <div className="asset-distribution">
          <div className="top">
            <div className="title">{t('资产分布')}</div>
            <Select
              value={assetDistributionType}
              options={[
                { label: t('操作系统'), value: 'os' },
                { label: t('影响组件'), value: 'component' },
              ]}
              onChange={handleAssetDistributionChange}
            />
          </div>

          <div className="chart">
            {assetDistributionChartData.length > 0 ? (
              <ReactECharts style={{ height: '100%', width: '100%' }} option={option3()} />
            ) : (
              <Empty image={EmptyImg} imageStyle={{ marginTop: '60px' }} />
            )}
          </div>
        </div>
        <div className="device-cover">
          <div className="title">{t('防护覆盖率')}</div>
          <div className="chart">
            {deviceCover?.length > 0 ? (
              <ReactECharts style={{ height: '90%', width: '100%' }} option={option1()} />
            ) : (
              <Empty image={EmptyImg} imageStyle={{ marginTop: '60px' }} />
            )}
          </div>
        </div>
        <div className="site-verify">
          <div className="title">{t('验证率')}</div>
          <div className="chart">
            {siteVerify?.length > 0 ? (
              <ReactECharts style={{ height: '90%', width: '100%' }} option={option2()} />
            ) : (
              <Empty image={EmptyImg} imageStyle={{ marginTop: '60px' }} />
            )}
          </div>
        </div>
      </AnalysisBox>
      <TableBox>
        <div className="filter-box">
          <div className="filter-title">{t('站点列表')}</div>
          <div className="filter-content">
            <FilterFormSelect
              filterOptions={[
                {
                  type: 'input',
                  label: t('站点名称'),
                  value: 'search',
                },
              ]}
              onChange={setSelectedValue}
              value={selectedValue}
            />
            <Button onClick={() => setBatchAddVisible(true)}>{t('批量导入')}</Button>
            <Button type={'primary'} style={{ marginLeft: 8 }} onClick={() => setAddVisible(true)}>
              {t('添加站点')}
            </Button>
          </div>
        </div>
        <div>
          {selected.length > 0 && (
            <div
              style={{
                marginBottom: 16,
                background: '#F5F5FF',
                padding: '8px 16px',
                borderRadius: '6px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Space split={<Divider type="vertical" />}>
                <div>
                  {t('已选择')} {selected.length} {t('项')}
                </div>
                <Delete
                  onClick={() => {
                    setDeleteVisible({ visible: true, id: selected })
                  }}
                >
                  <SvgIcon name="batch_remove" className="icon-delete" />
                  <span>{t('批量删除')}</span>
                </Delete>
                <Transfer
                  onClick={() => {
                    setConfigVisible({ visible: true, id: selected })
                  }}
                >
                  <SvgIcon name={'batch-config'} />
                  <span>{t('批量站点配置')}</span>
                </Transfer>
              </Space>
              <div
                onClick={() => {
                  setSelected([])
                }}
                style={{ cursor: 'pointer', color: '#666666' }}
                className="close-btn"
              >
                <IconFont type="icon-guanbi" style={{ fontSize: 12 }} />
              </div>
            </div>
          )}
          <Table
            rowKey="id"
            columns={columns}
            dataSource={siteList?.items}
            scroll={{ x: 1500 }}
            loading={siteListLoading}
            pagination={{
              total: siteList?.total,
              current: filterParams.page,
              pageSize: filterParams.size,
              showTotal: total => <ShowTotal>{total}</ShowTotal>,
              pageSizeOptions: ['10', '20', '30', '40', '50'],
              showSizeChanger: true,
              showQuickJumper: true,
            }}
            onChange={handleTableChange}
            rowSelection={{
              selectedRowKeys: selected,
              onChange: keys => {
                setSelected(keys as string[])
              },
            }}
          />
        </div>
      </TableBox>
      <AddSiteModal
        visible={addVisible}
        fingerprint={fingerprintData}
        onCancel={() => setAddVisible(false)}
        onOk={() => {
          setAddVisible(false)
          getDeviceList().catch(_ => {})
          setFilterParams({ ...filterParams, page: 1, size: 10 })
        }}
      />
      {editVisible.visible && (
        <EditSiteModal
          id={editVisible.id}
          originFrom={editVisible.originFrom}
          onCancel={() => setEditVisible({ id: '', visible: false, originFrom: null })}
          onOk={() => {
            setEditVisible({ visible: false, id: '', originFrom: null })
            getDeviceList().catch(_ => {})
            setFilterParams({ ...filterParams, page: 1, size: 10 })
          }}
        />
      )}
      <BatchAddModal visible={batchAddVisible} closeModal={closeBatchAddModal} />
      {configVisible.visible && (
        <DeviceConfigModal
          id={configVisible.id}
          onOk={() => {
            getDeviceList().catch(_ => {})
            setConfigVisible({
              id: [],
              visible: false,
            })
            setFilterParams({ ...filterParams, page: 1, size: 10 })
            setSelected([])
          }}
          onCancel={() =>
            setConfigVisible({
              id: [],
              visible: false,
            })
          }
        />
      )}
      <SiteDetailModal
        visible={{ visible: detail.visible && !!detail.id, id: detail.id || '' }}
        fingerprintData={fingerprintData}
        closeModal={() => setDetail(prev => ({ ...prev, visible: false, id: null }))}
      />
      <DeleteModal
        onOk={() => {
          deleteSite({ id: deleteVisible.id })
            .then(() => {
              setSelected([])
              setDeleteVisible({ visible: false, id: [] })
              getDeviceList().catch(_ => {})
              setFilterParams({ ...filterParams, page: 1, size: 10 })
            })
            .catch(_ => {})
        }}
        visible={deleteVisible.visible}
        title={<SignTitle show>{t('提示')}</SignTitle>}
        text={t('此操作将永久删除，是否继续?')}
        onCancel={() => {
          setDeleteVisible({ visible: false, id: [] })
        }}
      />
    </div>
  )
}

export default SiteList

const AnalysisBox = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  height: 300px;

  .title {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }

  .analysis-box {
    flex: 1;
    height: 100%;
    background: #fff;
    border-radius: 8px;
    display: flex;
    padding: 20px 20px 0;
    flex-direction: column;
    margin-right: 16px;

    .site-total {
      width: 100%;
      height: 100px;
      padding: 16px 0 16px 20px;
      margin-top: 20px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-direction: column;
      .total-title {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        line-height: 24px;
        text-align: left;
        font-style: normal;
      }
      .total {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 500;
        font-size: 24px;
        color: #ffffff;
        line-height: 36px;
        text-align: left;
        font-style: normal;
      }
    }

    .survival-total {
      height: 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 12px;
      border-bottom: 1px solid #d5d9dd;

      .title {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        padding-left: 12px;
        position: relative;

        &::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 26px;
          background: #2090a8;
          position: absolute;
          left: 0;
          top: -10%;
        }
      }
    }

    .deactivation-total {
      height: 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 12px;

      .title {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        padding-left: 12px;
        position: relative;

        &::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 26px;
          background: #fdce34;
          position: absolute;
          left: 0;
          top: -10%;
        }
      }
    }

    .validate-total {
      height: 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        padding-left: 12px;
        position: relative;

        &::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 26px;
          background: #fdce34;
          position: absolute;
          left: 0;
          top: -1px;
        }
      }
    }
  }

  .asset-distribution {
    background: #fff;
    border-radius: 8px;
    width: 100%;
    height: 100%;
    margin-right: 16px;
    padding: 12px 6px 0 12px;
    flex: 1;

    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
    }
  }

  .device-cover {
    background: #fff;
    border-radius: 8px;
    width: 100%;
    height: 100%;
    margin-right: 16px;
    padding: 20px 20px 0;
    flex: 1;
  }

  .site-verify {
    background: #fff;
    border-radius: 8px;
    width: 100%;
    height: 100%;
    padding: 20px 20px 0;
    flex: 1;
  }

  .chart {
    height: calc(100% - 30px);
    width: 100%;
  }
`

const TableBox = styled.div`
  width: 100%;
  height: calc(100% - 266px);
  overflow-y: scroll;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  .ant-table-measure-row {
    display: none;
  }
  .ant-table-column-sorters {
    justify-content: flex-start;
    .ant-table-column-sorter {
      padding-top: 4px;
      margin-left: 5px;
    }
    .ant-table-column-title {
      flex: none;
    }
  }

  .ant-table-filter-column {
    justify-content: flex-start;
    .ant-table-column-title {
      flex: none;
    }
  }
  .filter-box {
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .filter-title {
      font-size: 16px;
      font-weight: 500;
    }
    .filter-content {
      display: flex;
      align-items: center;
      .ant-btn {
        margin-left: 8px;
      }
    }
  }
  .close-btn {
    cursor: pointer;
    color: #666666;
    padding: 2px 4px;
    :hover {
      background: #ffffff;
      border-radius: 4px;
    }
  }
`

const ActionBar = styled.div`
  //.ant-dropdown-menu {
  //  width: 100px;
  //}
  //.ant-dropdown-menu-title-content {
  //  min-width: 62px;
  //}
  //.ant-dropdown-menu-item-active {
  //  background: #e7e9f3;
  //  color: #4238C9;
  //}
`

const Transfer = styled.div`
  width: 110px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  color: #333333;
  //background: #f2f3f5;
  border-radius: 6px;
  display: flex;
  /* margin-top: 16px; */
  margin-right: 10px;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  background-color: #f1f3f8;
  transition: 0.3s;
  font-weight: normal;
  &:hover {
    background-color: #ffffff;
  }
  svg {
    width: 16px;
    margin-right: 6px;
  }
`
const Delete = styled.div`
  width: 92px;
  height: 24px;
  line-height: 32px;
  font-size: 14px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #333;
  justify-content: center;
  transition: 0.3s;
  &:hover {
    background-color: #fff;
  }
  svg {
    width: 16px;
    margin-right: 6px;
  }
`
